const $ = window.jQuery;
const _debounce = require('lodash.debounce');


const RWD = function RWD(opts) {
  this.position = {
    w: null,
    h: null,
    breakpointType: null
  };

  this.setOptions(opts);
  this.init();
  return this;
};

RWD.prototype = {

  DEFAULTS: {
    screenSizes: {  // match up with Bootstrap's Sass variables
      xs: 320,
      sm: 600,
      md: 960,
      lg: 1180
    }
  },

  setOptions(options) {
    this.app = options.app;
    delete options.app;
    this.options = options ? $.extend({}, this.DEFAULTS, options) : this.options;
  },

  init() {
    this.calculateLayout();
    this.bindEvents();
  },

  bindEvents() {
    $(window).on('resize', _debounce($.proxy(this.calculateLayout, this), 200));
    return this;
  },

  calculateLayout() {
    this.position.w = window.innerWidth;
    this.position.h = window.innerHeight;
    $(window).trigger('browserResized');
    this.announceViewportType();
  },

  announceViewportType() {
    let self = this,
      w = self.position.w,
      currentBreakpointType = null;

    if (w < self.options.screenSizes.sm) {
      currentBreakpointType = 'xs';
    } else if (w >= self.options.screenSizes.sm && w < self.options.screenSizes.md) {
      currentBreakpointType = 'sm';
    } else if (w >= self.options.screenSizes.md && w < self.options.screenSizes.lg) {
      currentBreakpointType = 'md';
    } else if (w >= self.options.screenSizes.lg) {
      currentBreakpointType = 'lg';
    }

    if (currentBreakpointType !== self.breakpointType) {
      self.position.breakpointType = currentBreakpointType;
      if (!$.isEmptyObject(self.app._events)) {
        self.app.trigger('change:viewport', self.position);
      } else {
        $(document).trigger('change:viewport', self.position);
      }
    }
  }

};

module.exports = RWD;



// WEBPACK FOOTER //
// ./hui_core/scripts/components/responsive.js